import React from 'react';
import { Box, Table, TableHead, TableBody, TableRow, TableCell, Checkbox } from '@mui/material';
import { formatDate } from '../../utils/formatDate';
import { headCellSx, bodyCellSx } from '../listing';
import { tokens } from '../../theme';

const SortByTable = ({ sortBy, data, selectedList, setSelectedList }) => {
  const isDept = sortBy === "Departments";

  const handleToggle = (id, isChecked) => {
    setSelectedList((prev) => {
      const key = isDept ? "department" : "employeeGroup";
      const list = isChecked
        ? [...prev[key], id]
        : prev[key].filter((item) => item !== id);
      return { ...prev, [key]: list };
    });
  };

  const isSelected = (id) =>
    isDept ? selectedList?.department?.includes(id) : selectedList?.employeeGroup?.includes(id);

  const rows = data || [];

  if (rows.length === 0) {
    return (
      <Box sx={{ py: "2rem", textAlign: "center", fontSize: "0.875rem", color: tokens.textMuted }}>
        No {isDept ? "departments" : "groups"} found
      </Box>
    );
  }

  return (
    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ ...headCellSx, width: "3rem" }} padding="checkbox" />
          <TableCell sx={headCellSx}>{isDept ? "Department Name" : "Group Name"}</TableCell>
          <TableCell sx={headCellSx}>{isDept ? "Department Head" : "Created By"}</TableCell>
          <TableCell sx={headCellSx}>Created On</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          const selected = isSelected(row._id);
          return (
            <TableRow key={row._id} hover selected={selected}
              onClick={() => handleToggle(row._id, !selected)}
              sx={{ cursor: "pointer", "&:hover": { background: tokens.surfaceSubtle } }}>
              <TableCell sx={bodyCellSx} padding="checkbox" onClick={(e) => e.stopPropagation()}>
                <Checkbox size="small" checked={!!selected} onChange={(e) => handleToggle(row._id, e.target.checked)} />
              </TableCell>
              <TableCell sx={{ ...bodyCellSx, fontWeight: 600 }}>{row?.name || "—"}</TableCell>
              <TableCell sx={{ ...bodyCellSx, color: tokens.textMuted }}>{row?.head || "—"}</TableCell>
              <TableCell sx={{ ...bodyCellSx, color: tokens.textMuted }}>{formatDate(row?.createdAt)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default SortByTable;
